import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import styles from './content-explorer-footer.styles.css';
import {CprButtonIcon, CpButton, CprLoader} from 'canopy-styleguide!sofe';
import SaveToCanopyFilesDropdownContext from 'src/documents/save-to-canopy-files-dropdown/save-to-canopy-files-dropdown.context';

ContentExplorerFooter.propTypes = {
  docId: PropTypes.string,
  saveHandler: PropTypes.func,
  isSavingFile: PropTypes.bool.isRequired,
}

export default function ContentExplorerFooter(props) {
  const dispatch = useContext(SaveToCanopyFilesDropdownContext);

  return (
    <div className={styles.footer}>
      <div className={styles.left}>
        <CpButton
          btnType="primary"
          disabled={(!props.docId && !props.saveHandler) || !props.contactId}
          onClick={() => {
            if (!props.isSavingFile) {
              dispatch({type: 'save_file'})
            }
          }}
          className={styles.saveButton}
        >
          {props.isSavingFile ? (
            <CprLoader
              dotSize={12}
              color="var(--cps-color-bumble)"
              customClass={styles.loader}
            />
          ) : (
            `Save here`
          )}
        </CpButton>
      </div>
      <div className={styles.right}>
        {(!props.isSavingFile && !!props.contactId && (
          <CprButtonIcon
            icon="folder-add"
            ariaText="Create folder"
            onClick={() => dispatch({type: 'create_folder'})}
          />
        ))}
      </div>
    </div>
  )
}
